import React from 'react';
import defaulExpmtCover from '@/images/studio/empty.png';

const ShowEmpty = (props) => {
  const { style, imageStyle, src, desc, descStyle } = props;

  return (
    <div style={style || { margin: '19.73vw 29.47vw 5vw 24.4vw', overflow: 'hidden' }}>
      <div style={imageStyle || { width: '46.13vw', height: '20.67vw' }}>
        <img src={src || defaulExpmtCover} alt="" />
      </div>
      <div
        style={
          descStyle || {
            margin: '3.73vw 0 0 19.2vw',
            fontSize: '3.2vw',
            fontFamily: 'PingFang SC',
            fontWeight: 500,
            color: '#8E8E8E',
          }
        }
      >
        {desc || '暂无数据'}
      </div>
    </div>
  );
};

export default ShowEmpty;
